import { useFullRelease } from '@/common/hooks_useFullRelease';
import { GraphCore } from '@/components/GraphVisualisation/GraphViz';
import RuleGraphProvider from '@/components/GraphVisualisation/providers/RuleGraphProvider';
import { useSessionDecisionGraph, useSessionValidations } from '../sessionGraph';
import ReleaseContextProvider from '@/pages/models/release/ReleaseContextProvider';
import { DerivedTableDebugProvider } from '@/components/Debugger/DerivedTable/DerivedTableDebugContext';
import DerivedTableResultGrid from '@/components/Debugger/DerivedTable/DerivedTableResultGrid';
import DerivedTableToolbarControls from '@/components/Debugger/DerivedTable/DerivedTableToolbarControls';
import { StoredDerivedTableDataSourceProvider } from './DerivedTable/StoredDerivedTableDataSource';

import ValidationPanel from '@/components/ValidationPanel';

export const VisualisationsPanel = ({ session, release: releaseProp }: { session: any; release?: any }) => {
  const fullRelease = useFullRelease();
  const release = releaseProp ?? fullRelease;
  // the session's graph as a decision graph (converted once per graph)
  const graph = useSessionDecisionGraph();
  const goalId = graph?.ref(session.goal);
  const goal = goalId !== undefined ? graph!.deref(goalId) : session.goal;
  // the session's saved validations (an older session's are asked for while this panel is open)
  const validations = useSessionValidations(session, release);

  return (
    <RuleGraphProvider
      graph={graph}
      goal={goal}
      debug={true}
      hasNebula={true}
      hasData={true}
      hasDecisionReport={true}
      decisionReportDownloadContext={{
        modelName: (release as any)?.model?.name ?? (release as any)?.model_name ?? (release as any)?.modelName,
        releaseNo: release?.releaseNo,
        sessionId: session?.id ?? session?._id,
      }}
      extraVizTypes={[
        {
          id: "derivedtable",
          nameTranslationKey: "debugger.derived_table",
          component: DerivedTableResultGrid,
          toolbarComponent: DerivedTableToolbarControls,
        },
      ]}
    >
      {/* TODO remove me - legacy support */}
      <ReleaseContextProvider release={release as any}>
        <DerivedTableDebugProvider>
          <StoredDerivedTableDataSourceProvider session={session}>
            <GraphCore />
          </StoredDerivedTableDataSourceProvider>
        </DerivedTableDebugProvider>
      </ReleaseContextProvider>
      <ValidationPanel
        className="absolute bottom-2 right-2"
        validations={validations.validations}
        loading={validations.loading}
        error={validations.error}
      />
    </RuleGraphProvider>
  );
};
